// import React, { useEffect, useState } from 'react';
// import Llogo from '../img/Llogo.png';
// import { ArrowLeftOutlined } from '@ant-design/icons';
// import { useNavigate } from 'react-router-dom';

// const ContactWeb = () => {
//   const navigate = useNavigate();
  // const [contacts, setContacts] = useState([]);
  // const dist = sessionStorage.getItem("dist") || "320E";

  // useEffect(() => {
  //   fetch(`https://lionsdirectoryapi.emedha.in/contact/get?dist=${dist}`)
  //     .then(response => response.json())
  //     .then(data => setContacts(data))
  //     .catch(error => console.error('Error fetching contacts:', error));
  // }, [dist]);

//   return (
//     <div style={{
//       width: '365px',
//       minHeight: '557px',
//       maxHeight: '667px',
//       margin: '10px auto',
//       border: '1px solid #ccc',
//       borderRadius: '20px',
//       overflow: 'hidden',
//       boxShadow: '0 0 10px rgba(0,0,0,0.2)',
//       backgroundColor: '#f8f9fa',
//       display: 'flex',
//       flexDirection: 'column',
//       justifyContent: 'space-between'
//     }}>
      
//       {/* Header */}
//       <div style={{ padding: '10px' }}>
//         <div style={{ display: 'flex', alignItems: 'center', marginBottom: 20 }}>
//           <ArrowLeftOutlined
//             style={{ fontSize: '18px', color: '#0e3972', cursor: 'pointer', marginRight: '10px' }}
//             onClick={() => navigate('/home')}
//           />
//           <h6 style={{ color: '#0e3972', fontWeight: 'bold', margin: 0 }}>Contact Us</h6>
//         </div>

//         {/* Scrollable Contacts */}
//         <div style={{ maxHeight: '470px', overflowY: 'auto', paddingRight: 4 }}>
//           {contacts.map((contact, index) => (
//             <div key={contact.id || index} style={{
//               backgroundColor: '#fff',
//               borderRadius: 10,
//               padding: 15,
//               marginBottom: 15,
//               boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
//             }}>
//               <div style={{ textAlign: 'center', marginBottom: 10 }}>
//                 <img src={Llogo} alt="logo" style={{ height: 90, width: 90, borderRadius: '50%' }} />
//                 <p style={{ fontSize: 18, fontWeight: 'bold', marginTop: 8, color: '#333' }}>Lions {dist}</p>
//               </div>

//               <div style={{ display: 'flex', alignItems: 'center', margin: '6px 0' }}>
//                 <i className="fas fa-phone" style={{ color: 'rgb(14, 57, 114)', marginRight: 10 }}></i>
//                 <span style={{ fontSize: 16, color: '#444' }}>+91 {contact.mobile}</span>
//               </div>

//               <div style={{ display: 'flex', alignItems: 'center', margin: '6px 0' }}>
//                 <i className="fas fa-envelope" style={{ color: 'rgb(14, 57, 114)', marginRight: 10 }}></i>
//                 <span style={{ fontSize: 16, color: '#444' }}>{contact.email}</span>
//               </div>

//               <div style={{ display: 'flex', alignItems: 'center', margin: '6px 0' }}>
//                 <i className="fas fa-map-marker-alt" style={{ color: 'rgb(14, 57, 114)', marginRight: 10 }}></i>
//                 <span style={{ fontSize: 16, color: '#444' }}>{contact.address}</span>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* Footer */}
//       <div style={{ padding: '10px' }}>
//         <a
//           href="https://emedha.com"
//           target="_blank"
//           rel="noopener noreferrer"
//           style={{
//             display: 'block',
//             backgroundColor: 'rgb(27, 6, 71)',
//             borderRadius: 14,
//             height: 58,
//             textAlign: 'center',
//             color: '#fff',
//             fontWeight: 'bold',
//             fontSize: 18,
//             lineHeight: '27px',
//             paddingTop: 8,
//             textDecoration: 'none'
//           }}
//         >
//           Website E Medha Technologies
//           <div style={{ fontSize: 15, color: 'hsl(221, 98%, 51%)', paddingBottom: 18 }}>https://emedha.com</div>
//         </a>
//       </div>
//     </div>
//   );
// };

// export default ContactWeb;


import React, { useEffect, useState } from 'react';
import { ChevronLeft, Phone, Mail, MapPin, Globe, Send, PhoneCall } from 'lucide-react';

const ContactWeb = ({ onBack, styles }) => {
  // State for the Contact Form
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Submitted:", formData);
    alert("Message Sent Successfully!");
    setFormData({ name: '', email: '', message: '' }); // Reset form
  };


    const [contacts, setContacts] = useState([]);
  const dist = sessionStorage.getItem("dist") || "320E";

  useEffect(() => {
    fetch(`https://lionsdirectoryapi.emedha.in/contact/get?dist=${dist}`)
      .then(response => response.json())
      .then(data => setContacts(data))
      .catch(error => console.error('Error fetching contacts:', error));
  }, [dist]);


  const ContactInfoItem = ({ icon: Icon, label, value, isLink }) => (
    <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '20px' }}>
      <div style={{ 
        backgroundColor: '#E8EEFB', color: '#0033A0', width: '35px', height: '35px', 
        borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' 
      }}>
        <Icon size={18} />
      </div>
      <div>
        <div style={{ fontSize: '11px', color: '#888', marginBottom: '2px' }}>{label}</div>
        <div style={{ 
          fontSize: '14px', 
          color: isLink ? '#0033A0' : '#000', 
          fontWeight: '600',
          textDecoration: isLink ? 'underline' : 'none'
        }}>
          {value}
        </div>
      </div>
    </div>
  );

  return (
    <div style={styles.scrollArea}>
      {/* Navigation Header */}
      <div 
        onClick={onBack} 
        style={{ padding: '15px 15px 5px', display: 'flex', alignItems: 'center', color: '#0033A0', cursor: 'pointer' }}
      >
        <ChevronLeft size={20} />
        <span style={{ fontSize: '14px', fontWeight: '600' }}>Back to Home</span>
      </div>

      {/* Page Title Section */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '15px', padding: '10px 15px 20px' }}>
        <div style={{ 
          backgroundColor: '#FFC20E', color: 'white', width: '45px', height: '45px', 
          borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' 
        }}>
          <PhoneCall size={24} />
        </div>
        <h1 style={{ fontSize: '24px', color: '#0033A0', margin: 0 }}>Contact Us</h1>
      </div>

      <div style={{ padding: '0 15px' }}>
        {/* Get in Touch Card */}
        <div style={{
          backgroundColor: 'white', borderRadius: '12px', padding: '20px',
          marginBottom: '20px', border: '1px solid #eee', boxShadow: '0 2px 4px rgba(0,0,0,0.02)'
        }}>
          <h3 style={{ margin: '0 0 20px 0', color: '#0033A0', fontSize: '18px' }}>Get in Touch</h3>
         {contacts.length > 0 ? (
  contacts.map((contact, index) => (
    <React.Fragment key={index}>
      
      {contact.phone && (
        <ContactInfoItem
          icon={Phone}
          label="Phone"
          value={
            <a href={`tel:${contact.phone}`} style={{ color: '#0033A0', textDecoration: 'none' }}>
              {contact.phone}
            </a>
          }
        />
      )}

      {contact.email && (
        <ContactInfoItem
          icon={Mail}
          label="Email"
          value={
            <a href={`mailto:${contact.email}`} style={{ color: '#0033A0' }}>
              {contact.email}
            </a>
          }
        />
      )}

      {contact.address && (
        <ContactInfoItem
          icon={MapPin}
          label="Address"
          value={contact.address}
        />
      )}

      {contact.website && (
        <ContactInfoItem
          icon={Globe}
          label="Website"
          value={
            <a
              href={`https://${contact.website}`}
              target="_blank"
              rel="noreferrer"
              style={{ color: '#0033A0' }}
            >
              {contact.website}
            </a>
          }
        />
      )}

    </React.Fragment>
  ))
) : (
  <div style={{ color: '#888' }}>No contact details available</div>
)}
        </div>

        {/* Send Message Card */}
        <div style={{
          backgroundColor: 'white', borderRadius: '12px', padding: '20px',
          marginBottom: '30px', border: '1px solid #eee', boxShadow: '0 2px 4px rgba(0,0,0,0.02)'
        }}>
          <h3 style={{ margin: '0 0 20px 0', color: '#0033A0', fontSize: '18px' }}>Send us a Message</h3>
          
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: '15px' }}>
              <label style={{ display: 'block', fontSize: '13px', fontWeight: 'bold', marginBottom: '5px' }}>Name</label>
              <input 
                type="text" name="name" placeholder="Your Name" required
                value={formData.name} onChange={handleChange}
                style={{ width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid #ddd', boxSizing: 'border-box' }}
              />
            </div>

            <div style={{ marginBottom: '15px' }}>
              <label style={{ display: 'block', fontSize: '13px', fontWeight: 'bold', marginBottom: '5px' }}>Email</label>
              <input 
                type="email" name="email" placeholder="your@email.com" required
                value={formData.email} onChange={handleChange}
                style={{ width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid #ddd', boxSizing: 'border-box' }}
              />
            </div>

            <div style={{ marginBottom: '20px' }}>
              <label style={{ display: 'block', fontSize: '13px', fontWeight: 'bold', marginBottom: '5px' }}>Message</label>
              <textarea 
                name="message" rows="4" placeholder="Your message..." required
                value={formData.message} onChange={handleChange}
                style={{ width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid #ddd', boxSizing: 'border-box', fontFamily: 'inherit' }}
              />
            </div>

            <button type="submit" style={{
              width: '100%', backgroundColor: '#FFC20E', border: 'none', padding: '15px',
              borderRadius: '10px', fontWeight: 'bold', fontSize: '16px', cursor: 'pointer',
              color: '#333', boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
            }}>
              Send Message
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactWeb;
